import ProductSpecifications, {
  Table
} from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';

const Wrapper = styled('div')`
  ${Table} {
    tr th {
      padding-left: 0.5rem;
      min-width: 150px;
    }
    tr:nth-of-type(2n-1) {
      //background: ${theme.colors.greys[1]};
    }
    tbody > tr {
      background: none;
      border-bottom: 1px solid ${theme.colors.border};
      height: 40px;
      ${theme.above.md} {
        &:nth-of-type(2n + 1) {
        }
      }
    }
  }
`;

export const ProductSpecificationsWrapper = ({ className, fields }) => {
  return (
    <Wrapper>
      <ProductSpecifications className={className} fields={fields} />
    </Wrapper>
  );
};
